<div *ngIf="(!configurationsByInterval || configurationsByInterval.size == 0)">
  <div class="recents-interval welcome-message-title">
    <h4 class="text-uppercase start-search-header">{{welcomeTitle}}</h4>
  </div>

  <div class="col px-3 hide-overflow link-detail welcome-message-body">
    <div class="description" [innerHtml]="welcomeMessage | safeHtml"></div>
  </div>
</div>